import { Component, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonInput, IonItem, IonLabel, IonSelect, IonSelectOption, IonTextarea, IonTitle, IonToolbar } from '@ionic/angular/standalone';
import { PosClient } from '@adminpages/pos-api';
import { PosStoreService } from '@adminpages/pos-state';
import { RepairsStoreService } from '@adminpages/repairs-state';

@Component({
  selector: 'foco-repair-new-page',
  standalone: true,
  imports: [FormsModule, RouterLink, IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonInput, IonItem, IonLabel, IonSelect, IonSelectOption, IonTextarea, IonTitle, IonToolbar],
  template: `
    <ion-header><ion-toolbar>
      <ion-buttons slot="start"><ion-button routerLink="/repairs"><ion-icon name="arrow-back" slot="icon-only"></ion-icon></ion-button></ion-buttons>
      <ion-title>Nueva recepción</ion-title>
    </ion-toolbar></ion-header>
    <ion-content class="pos-page form-content"><main class="form-shell">
      <section class="form-section">
        <header><span>Cliente</span><h1>Datos de contacto</h1></header>
        <div class="client-search">
          <ion-item><ion-label position="stacked">Buscar por nombre, teléfono o email</ion-label><ion-input [(ngModel)]="clientQuery"></ion-input></ion-item>
          <ion-button fill="outline" (click)="searchClients()">Buscar</ion-button>
        </div>
        @if (clientResults().length) {
          <div class="client-results">
            @for (client of clientResults(); track client.id) {
              <button type="button" [class.selected]="selectedClient()?.id === client.id" (click)="selectedClient.set(client)"><strong>{{ client.name }}</strong><small>{{ client.phone || client.email }}</small></button>
            }
          </div>
        }
        @if (!selectedClient()) {
          <div class="form-grid">
            <ion-item><ion-label position="stacked">Nombre nuevo cliente</ion-label><ion-input [(ngModel)]="clientName"></ion-input></ion-item>
            <ion-item><ion-label position="stacked">Teléfono</ion-label><ion-input [(ngModel)]="clientPhone" type="tel"></ion-input></ion-item>
            <ion-item><ion-label position="stacked">Email</ion-label><ion-input [(ngModel)]="clientEmail" type="email"></ion-input></ion-item>
          </div>
        } @else {
          <div class="selected-client"><strong>{{ selectedClient()?.name }}</strong><span>{{ selectedClient()?.phone || selectedClient()?.email }}</span><ion-button fill="clear" size="small" (click)="selectedClient.set(null)">Cambiar</ion-button></div>
        }
      </section>

      <section class="form-section">
        <header><span>Equipo</span><h2>Recepción física</h2></header>
        <div class="form-grid">
          <ion-item><ion-label position="stacked">Tipo de equipo</ion-label><ion-input [(ngModel)]="assetType" placeholder="Teléfono, laptop, tableta"></ion-input></ion-item>
          <ion-item><ion-label position="stacked">Marca</ion-label><ion-input [(ngModel)]="brand"></ion-input></ion-item>
          <ion-item><ion-label position="stacked">Modelo</ion-label><ion-input [(ngModel)]="model"></ion-input></ion-item>
          <ion-item><ion-label position="stacked">Número de serie</ion-label><ion-input [(ngModel)]="serialNumber"></ion-input></ion-item>
          <ion-item><ion-label position="stacked">Color</ion-label><ion-input [(ngModel)]="color"></ion-input></ion-item>
          <ion-item><ion-label position="stacked">Prioridad</ion-label><ion-select [(ngModel)]="priority"><ion-select-option value="normal">Normal</ion-select-option><ion-select-option value="urgent">Urgente</ion-select-option></ion-select></ion-item>
        </div>
        <ion-item><ion-label position="stacked">Falla reportada</ion-label><ion-textarea [(ngModel)]="reportedIssue" [autoGrow]="true"></ion-textarea></ion-item>
        <ion-item><ion-label position="stacked">Condición física</ion-label><ion-textarea [(ngModel)]="physicalCondition" [autoGrow]="true"></ion-textarea></ion-item>
        <ion-item><ion-label position="stacked">Accesorios recibidos</ion-label><ion-textarea [(ngModel)]="accessories" [autoGrow]="true"></ion-textarea></ion-item>
        <ion-item><ion-label position="stacked">Clave o patrón de acceso</ion-label><ion-input [(ngModel)]="accessCredentials" type="password"></ion-input></ion-item>
      </section>

      @if (repairs.errorMessage(); as error) { <section class="error">{{ error }}</section> }
      <ion-button expand="block" size="large" [disabled]="repairs.saving() || !canSave()" (click)="save()">{{ repairs.saving() ? 'Guardando...' : 'Recibir equipo' }}</ion-button>
    </main></ion-content>
  `,
  styles: `
    .form-content { --padding-bottom: calc(48px + var(--ion-safe-area-bottom, 0px)); --padding-end: 18px; --padding-start: 18px; --padding-top: 18px; }
    .form-shell { display: grid; gap: 16px; margin: 0 auto; max-width: 980px; }
    .form-section { background: var(--pos-color-surface); border: 1px solid var(--pos-color-border); border-radius: 8px; display: grid; gap: 12px; padding: 18px; }
    header span { color: var(--pos-color-primary); font-size: 12px; font-weight: 800; text-transform: uppercase; }
    h1, h2 { font-size: 23px; margin: 4px 0 0; }
    .form-grid { display: grid; gap: 10px; grid-template-columns: repeat(3, minmax(0, 1fr)); }
    ion-item { --background: var(--pos-color-input); --border-radius: 8px; --color: var(--pos-color-text); }
    .client-search { align-items: end; display: grid; gap: 10px; grid-template-columns: 1fr auto; }
    .client-results { display: grid; gap: 8px; grid-template-columns: repeat(auto-fill, minmax(220px, 1fr)); }
    .client-results button { background: var(--pos-color-input); border: 1px solid var(--pos-color-border); border-radius: 8px; color: var(--pos-color-text); display: grid; gap: 4px; padding: 12px; text-align: left; }
    .client-results button.selected { border-color: var(--pos-color-primary); }
    .client-results small, .selected-client span { color: var(--pos-color-muted); }
    .selected-client { align-items: center; background: var(--pos-color-input); border-radius: 8px; display: grid; gap: 3px; grid-template-columns: 1fr auto; padding: 12px; }
    .selected-client span { grid-column: 1; }
    .selected-client ion-button { grid-column: 2; grid-row: 1 / span 2; }
    .error { color: var(--pos-color-danger); }
    @media (max-width: 720px) { .form-grid { grid-template-columns: 1fr; } .client-search { grid-template-columns: 1fr; } }
  `,
})
export class RepairNewPageComponent {
  private readonly router = inject(Router);
  readonly pos = inject(PosStoreService);
  readonly repairs = inject(RepairsStoreService);
  readonly clientResults = signal<PosClient[]>([]);
  readonly selectedClient = signal<PosClient | null>(null);
  clientQuery = ''; clientName = ''; clientPhone = ''; clientEmail = '';
  assetType = ''; brand = ''; model = ''; serialNumber = ''; color = ''; priority: 'normal' | 'urgent' = 'normal';
  reportedIssue = ''; physicalCondition = ''; accessories = ''; accessCredentials = '';

  async searchClients(): Promise<void> { this.clientResults.set(await this.pos.searchClients(this.clientQuery)); }
  canSave(): boolean { return Boolean(this.assetType.trim() && this.reportedIssue.trim() && (this.selectedClient() || this.clientName.trim() || this.clientPhone.trim() || this.clientEmail.trim())); }

  async save(): Promise<void> {
    try {
      let client = this.selectedClient();
      if (!client) client = await this.pos.createClient({ name: this.clientName, phone: this.clientPhone, email: this.clientEmail });
      const repair = await this.repairs.create({
        client_id: client.id, priority: this.priority, asset_type: this.assetType.trim(), brand: this.brand.trim() || undefined,
        model: this.model.trim() || undefined, serial_number: this.serialNumber.trim() || undefined, color: this.color.trim() || undefined,
        access_credentials: this.accessCredentials || undefined, reported_issue: this.reportedIssue.trim(),
        physical_condition: this.physicalCondition.trim() || undefined, accessories_received: this.accessories.trim() || undefined,
      });
      void this.router.navigate(['/repairs', repair.uuid]);
    } catch { /* El store presenta el error. */ }
  }
}
